
  import { computed, defineComponent, ref } from "vue";
  import { WordInterface } from "@/models/words"
  import { useStore } from "vuex";

  export default defineComponent({
    name: "DictionaryTable",
    props: {
      currentPage: Number
    },
    inject: ["Ti18N"],
    setup(props: any) {
      const store = useStore()
      const userID = computed(() => store.getters.userID)
      const currentDictionary = computed(() => store.getters.currentDictionary)
      const sortedWords = computed(() => store.getters.sortedWords)

      const transcription = ref<string | null>("")
      const newTranscription = ref<string | null>("")

      const setTranscription = (word: string, newTrscp: string) => {
        transcription.value = word
        newTranscription.value = newTrscp
      }

      const saveTranscription = async (wordInfo: WordInterface) => {
        const data = { ...wordInfo, transcription: newTranscription.value }
        const index = currentDictionary.value.words.findIndex((item: any) => item.id == wordInfo.id)

        if (index != -1) {
          await store.dispatch("saveDitionaryTranscription", {
            userID: userID.value,
            wordData: data,
            wordIndex: index,
            query: props.currentPage - 1,
          })
        }
        newTranscription.value = ""
        transcription.value = null
      }

      return {
        setTranscription, saveTranscription, transcription,
        sortedWords, currentDictionary, newTranscription
      }
    }
  })
